
import {
  computed, defineComponent, onMounted, provide, reactive, ref,
} from 'vue';
import {
  Tree, Table, ConfigProvider, Input, Switch, message,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { useStore, } from 'vuex';
import { postRequest, } from '@/request/request';
import {
  getAccountList, queryAccountRegion, updateUser,updateStatus,
} from '../../accountReq';
import newMadal from '../../components/newModal/index.vue';

const { Search, } = Input;

export default defineComponent({
  components: {
    Tree,
    Search,
    Table,
    ConfigProvider,
    Switch,
    newMadal,
  },
  setup () {
    const store = useStore();
    // 当前搜索参数
    const search = reactive<any>({
      keyWord: '',
    });

    const selectedKeys = ref<string[]>([]);
    const expandedKeys = ref<string[]>([]);
    const selectedLevel = ref<number>();

    // 单行信息
    const itemInfo = ref<any>({});
    const tableData = ref<any>([]);

    const roleData = ref<any>();

    provide(
      'itemInfo',
      computed(() => itemInfo.value)
    );

    // 分页
    const current = ref<number>(1);
    const total = ref<number>(0);
    const curPageSize = ref<number>(10);

    // 弹窗
    const popInfo = reactive({
      show: false,
      type: '',
    });

    const treeData = ref<any[]>([]);

    const userLevelLists = ['',
      '省级',
      '市级',
      '区县级',];

    // 列表行配置
    const columns = [
      {
        title: '序号',
        align: 'center',
        dataIndex: 'index',
        customRender: (item: any) => (current.value - 1) * curPageSize.value + item.index + 1,
        width: '5%',
      },
      {
        title: '省',
        dataIndex: 'province',
        customRender: (item: any) => item.text || '/',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '市',
        dataIndex: 'city',
        customRender: (item: any) => item.text || '/',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '县',
        dataIndex: 'county',
        customRender: (item: any) => item.text || '/',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '级别',
        dataIndex: 'userLevel',
        customRender: (item: any) => userLevelLists[Number(item.text)],
        ellipsis: true,
        align: 'center',
      },
      {
        title: '用户姓名',
        dataIndex: 'accountName',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '账号',
        dataIndex: 'tel',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '密码',
        dataIndex: 'password',
        customRender: (item: any) => item.text.replace(/./g, '*'),
        ellipsis: true,
        align: 'center',
      },
      {
        title: '使用组织',
        dataIndex: 'companyName',
        ellipsis: true,
        align: 'center',
      },
      {
        title: '到期时间',
        dataIndex: 'expirationTime',
        ellipsis: true,
        align: 'center',
        width: '12%',
      },
      {
        title: '状态',
        dataIndex: 'openType',
        slots: { customRender: 'openType', },
        ellipsis: true,
        align: 'center',
        width: '7%',
      },
      {
        title: '锁定',
        dataIndex: 'isFrozen',
        slots: { customRender: 'isFrozen', },
        ellipsis: true,
        align: 'center',
        width: '5%',
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'paramType',
        slots: { customRender: 'op', },
      },
    ];

    const getTreeList = async () => {
      const res = await queryAccountRegion(1);

      const { data, } = res || {};

      treeData.value = data || [];
    };

    // 加载表格数据
    const loadTable = async (pageNum = 1, pageSize = 10) => {
      const { keyWord, } = search;
      const id = selectedKeys.value[0];
      const params: any = {
        accountType: 1,
        tel: keyWord,
        regionId: id,
        regionLevel: selectedLevel.value,
        pageNum,
        pageSize,
      };
      const res: any = await getAccountList(params);
      const { data, } = res || {};

      tableData.value = data.list;
      total.value = data.total;
    };

    // 查询选项重置
    const handleReset = () => {
      search.keyWord = '';
    };

    // 查询
    const handleSearch = () => {
      current.value = 1;
      curPageSize.value = 10;
      total.value = 0;
      loadTable();
    };

    // 选择树节点
    const select = (keys:string[],e:any) => {
      const { selected, node, } = e;
      const { regionLevel, } = node.dataRef;

      selectedLevel.value = selected ? regionLevel : '';

      handleSearch();
    };

    // 表格变化回调
    const handleChange = (page: any, pageSize: any) => {
      current.value = page;
      loadTable(page, pageSize);
    };

    // 显示页数变化回调
    const sizeChange = (cur: any, size: any) => {
      current.value = cur;
      curPageSize.value = size;

      loadTable(cur, size);
    };

    // 点击编辑
    const handleEdit = (item?: any) => {
      itemInfo.value = item || {};
      popInfo.type = item ? 'edit' : 'add';
      popInfo.show = true;
      if (item) {
        store.dispatch('userCenter/getDataType', item.roleId).then((data) => {
          roleData.value = data.dataType;
        });
      }
    };
    // 点击删除
    const handleDel = async (item?: any) => {
    //  loadTable(current.value, curPageSize.value);
    };

    // 账号解锁
    const handleUnlock = (record: any): void => {
      store.dispatch('userCenter/unlockUser', [record.userId,]).then(() => {
        loadTable(current.value, curPageSize.value);
      });
    };

    // 点击状态开关
    const switchClick = (value: any): void => {
      updateStatus({
        id: value.id,
        openType: value.openType === 1 ? 2 : 1,
      }).then(() => {
        loadTable(current.value, curPageSize.value);
      });
    };

    // 取消弹窗
    const cancelPop = () => {
      popInfo.show = false;
    };

    // 保存弹窗
    const savePop = () => {
      popInfo.show = false;

      getTreeList();
      loadTable(current.value, curPageSize.value);
    };

    onMounted(() => {
      getTreeList();
      handleSearch();
    });

    return {
      zhCN,
      treeData,
      columns,
      search,
      tableData,
      itemInfo,
      current,
      total,
      curPageSize,
      popInfo,
      selectedKeys,
      expandedKeys,
      roleData,
      select,
      handleReset,
      handleSearch,
      sizeChange,
      handleChange,
      cancelPop,
      savePop,
      handleEdit,
      handleUnlock,
      handleDel,
      switchClick,
    };
  },
});
